import React from 'react'
import classNames from 'classnames'
import styles from './index.module.less'

export default () => {
  return <div className={styles.workbenchSkeleton}>
    <div className={styles.workbenchSkeletonLeft} />
    <div className={styles.workbenchSkeletonRight}>
      <div className={styles.workbenchSkeletonHeader}>
        <div className={classNames(styles.workbenchSkeletonHeaderLeft, styles.workbenchSkeleton_animation)} />
        <div className={classNames(styles.workbenchSkeletonHeaderRight, styles.workbenchSkeleton_animation)} />
      </div>
      <div className={styles.workbenchSkeletonContent}>
        <div className={classNames(styles.workbenchSkeletonContentLeft, styles.workbenchSkeleton_animation)} />
        <div className={classNames(styles.workbenchSkeletonContentRight, styles.workbenchSkeleton_animation)} />
      </div>
      <div className={styles.workbenchSkeletonContent2}>
        <div className={styles.workbenchSkeletonContent2Header}>
          <div className={classNames(styles.workbenchSkeletonContent2HeaderLeft, styles.workbenchSkeleton_animation)} />
          <div className={classNames(styles.workbenchSkeletonContent2HeaderRight, styles.workbenchSkeleton_animation)} />
        </div>
        <div className={classNames(styles.workbenchSkeletonContentLine1, styles.workbenchSkeleton_animation)} />
        <div className={classNames(styles.workbenchSkeletonContentLine2, styles.workbenchSkeleton_animation)} />
      </div>
      <div className={styles.workbenchSkeletonContent3}>
        <div className={classNames(styles.workbenchSkeletonContent3Header, styles.workbenchSkeleton_animation)} />
        <div className={styles.workbenchSkeletonContent3Line1}>
          <div className={classNames(styles.workbenchSkeletonContent3Card, styles.workbenchSkeleton_animation)} />
          <div className={classNames(styles.workbenchSkeletonContent3Card, styles.workbenchSkeleton_animation)} />
          <div className={classNames(styles.workbenchSkeletonContent3Card, styles.workbenchSkeleton_animation)} />
          <div className={classNames(styles.workbenchSkeletonContent3Card, styles.workbenchSkeleton_animation)} />
          <div className={classNames(styles.workbenchSkeletonContent3Card, styles.workbenchSkeleton_animation)} />
        </div>
      </div>
    </div>
  </div>
}
